import React from 'react'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section.js'

const MMycrocast = () => {
  return (
    <Section baseClass="m-SocialWall" defaultPaddingTop="large" defaultPaddingBottom="extra-large" data>
      <div className="m-Formblock-wrapper">
        {/* TODO: ConsentBanner after usercentrics scan */}
        {/*<CConsentBanner serviceName="mycrocast">*/}
        <iframe
          frameBorder="0"
          src="https://mycrocast-webplayer.s3.eu-central-1.amazonaws.com/dynamic_index.html?token=1630661588643_9a4bb2cf-43d0-44ae-9728-01ac50ae3464"
          style={{
            display: 'block',
            width: '100%',
            maxWidth: '500px',
            height: '800px',
            margin: '0 auto',
          }}
        ></iframe>
        {/*</CConsentBanner>*/}
      </div>
    </Section>
  )
}

export default MMycrocast
